import jsonSafe from './jsonSafe';

export default jsonSafe;
